import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CommonDataService } from '@sb-tools/typescript/services/common-data.service';
import { environment } from '@environment';
import { Tag } from '@sb-tools/typescript/models/tag.model';
import { TranslateModule } from '@ngx-translate/core';
import { TagsInputComponent } from '@form-field-module/tags-input/tags-input.component';
import { InlineSVGComponent } from '../../../Frontend-Inline-SVG-Module/inline-svg.component';
import { LinkyModule } from 'ngx-linky';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-add-tags-modal',
    templateUrl: './add-tags-modal.component.html',
    styleUrls: ['./add-tags-modal.component.scss'],
    imports: [TranslateModule, TagsInputComponent, InlineSVGComponent, LinkyModule, NgClass],
})
export class AddTagsModalComponent implements OnInit {
    alertMessage: string;
    communityName: string;
    confirmCallback: (tags: Tag[]) => void;
    environment = environment;
    tags: Tag[];
    entity?;
    isAdmin: boolean;
    isTagCreationEnabled: boolean;
    isReply?: boolean;
    isRequired?: boolean;
    isSubmitted?: boolean;
    newTags: Tag[] = [];
    onClose?: () => void;

    constructor(
        private commonDataService: CommonDataService,
        private modalRef: BsModalRef,
    ) {}

    ngOnInit() {
        this.newTags = structuredClone(this.entity?.tags) || [];
        this.communityName = this.commonDataService.communityName;
        this.isAdmin = this.commonDataService.user.isAdmin;
        this.isTagCreationEnabled = this.commonDataService.customerSettings.isTagCreationEnabled;
    }

    decline(): void {
        this.modalRef.hide();

        if (this.onClose) {
            this.onClose();
        }
    }

    save(): void {
        if (this.isRequired && !this.newTags.length) {
            this.isSubmitted = true;
            return;
        }
        this.confirmCallback(this.newTags);
        this.modalRef.hide();
    }
}
